import React, {useMemo} from 'react';

import './Controller.sass';
import {Button} from '~library/atoms/Button';

export const Controller = ({activeIndex, updateIndex, quantityOfItems, onClickDone}) => {
  const lastItem = activeIndex === quantityOfItems - 1;

  const dotsMemoized = useMemo(() => {
    const dots = [];
    for (let i = 0; i < quantityOfItems; i++) {
      dots.push(
        <button
          className={`create_flow__carousel__indicators__center__dot ${
            i === activeIndex && 'create_flow__carousel__indicators__center__dot--active'
          }`}
          onClick={() => {
            updateIndex(i);
          }}
          key={`onboard-dot-${i}`}
          data-qa-id={`onboard-dot-${activeIndex + 1}`}
        />
      );
    }
    return dots;
  }, [activeIndex, updateIndex, quantityOfItems]);

  return (
    <div className="create_flow__carousel__indicators">
      <div className="create_flow__carousel__indicators__left_button">
        {activeIndex !== 0 && (
          <Button
            onClick={() => {
              updateIndex(activeIndex - 1);
            }}
            data-qa-id="onboard-previous"
            variant="link"
            size="large"
          >
            Previous
          </Button>
        )}
      </div>

      <div className="create_flow__carousel__indicators__center">
        <div>{dotsMemoized}</div>
      </div>

      <div className="create_flow__carousel__indicators__right_button">
        <Button
          onClick={() => {
            lastItem ? onClickDone() : updateIndex(activeIndex + 1);
          }}
          data-qa-id="onboard-next"
          variant="link"
          size="large"
        >
          {lastItem ? 'Done' : 'Next'}
        </Button>
      </div>
    </div>
  );
};
